import React, { useState } from "react";
import "./customer_dashboard.css";
// import Header from "../../Header/Header";
import NewHeader from "../../NewHeader/NewHeader";
import Footer from "../../Footer/Footer";
import TopNav from "../../TopNav/TopNav";
import { Link } from "react-router-dom";
import { FaUserCircle } from "react-icons/fa";
import { GrDocumentPerformance, GrDocumentTest } from "react-icons/gr";

import {
  getCartDetails,
  getCustomerDashboard,
  customerBookingDetails,
} from "../../../Redux/Actions";
// import { getCustomerDashboardReducer } from "../../../Redux/Reducers";
import { useEffect } from "react";
// import { GET_CUSTOMER_DASHBOARD_SUCCESS } from '../../../Redux/Constants';
import { useDispatch, useSelector } from "react-redux";
// import { data } from "../../../Pages/packageDetailsPage/Data/AccreditationsData";
import { useHistory } from "react-router-dom";
import { Scroll } from "../../Scroll function/scroll";

const CustomerDashboard = () => {
  useEffect(() => {
    scroll();
  }, []);
  const history = useHistory();

  //IF TOKEN DOESN'T EXIST

  //RETRIEVING CUSTOMER BOOKING DETAILS FROM STORE
  const BookingDetails = useSelector((state) => state.customerBookingDetails);
  // console.log(
  //   "customer Booking details ",
  //   BookingDetails.customerDetailResponse.results[0].packages.length
  // );
  //RETRIEVING CUSTOMER'S DETAILS DATA FROM STORE
  const dispatch = useDispatch();
  const customerData = useSelector((state) => state.customerDashboard);
  const { loading, packages } = customerData;
  const { profile } = packages;

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const currentcity = citySelected.citySelect;
  //CALLING CUSTOMER DETAILS ACTION
  useEffect(() => {
    const datakey = JSON.parse(localStorage.getItem("user"));
    console.log(datakey);
    const token = datakey.token;
    console.log("token", token);
    dispatch(getCustomerDashboard(token));
    dispatch(getCartDetails(token, currentcity));
    dispatch(customerBookingDetails(token));
  }, []);

  return (
    <div>
      {/* <TopNav /> */}
      <NewHeader />
      <div className="Main_div">
        <div className="Heading_div">
          <h1>Customer Dashboard</h1>
        </div>
        {loading ? (
          "loading "
        ) : (
          <div className="div_container">
            <Link style={{ color: "#0e6b62;" }} to="/mybookings">
              <div className="divBlocks">
                <FaUserCircle fontSize="9rem" className="dashboard_icons" />
                <div className="headerCenter">
                  <h3 className="blocks">User Details</h3>{" "}
                </div>
              </div>
            </Link>
            {/* <Link to="/mybookings" >
              <div className="divBlocks">
                <GrDocumentPerformance
                  fontSize="6rem"
                  className="dashboard_icons"
                />
                <h3 className="blocks">My Bookings</h3>
              </div>
            </Link> */}
            {/* <Link to="/report">
              <div className="divBlocks">
                <GrDocumentTest fontSize="6rem" className="dashboard_icons" />
                <h3 className="blocks">My Report</h3>
              </div>
            </Link> */}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default {
  component: CustomerDashboard,
};
